import React from 'react';
import { useDisputesLeaderboard } from '../../../hooks/admin/useDisputesLeaderboard';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Badge } from '../../ui/badge';
import { Link } from 'react-router-dom';
import { TrendingUp } from 'lucide-react';

export function DisputesLeaderboard({ range = '90d' }) {
  const { data, isLoading, error } = useDisputesLeaderboard(range, 10);

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-base">Most Disputes ({range})</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="animate-pulse h-12 bg-gray-100 rounded"></div>
            ))}
          </div>
        </CardContent>
      </Card>
    );
  }

  if (error || !data || !data.sellers) {
    return null;
  }

  return (
    <Card className="sticky top-4">
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2">
          <TrendingUp className="h-4 w-4" />
          Most Disputes ({range})
        </CardTitle>
      </CardHeader>
      <CardContent>
        {data.sellers.length === 0 ? (
          <p className="text-sm text-gray-600">No dispute data for this period.</p>
        ) : (
          <div className="space-y-3">
            {data.sellers.map((seller, idx) => (
              <div key={seller.seller_id} className="flex items-start justify-between">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-semibold text-gray-400">#{idx + 1}</span>
                    <Link
                      to={`/seller/${seller.seller_id}`}
                      className="text-sm font-medium text-blue-600 hover:underline truncate"
                    >
                      {seller.name || 'Unknown'}
                    </Link>
                  </div>
                  <div className="flex items-center gap-2 mt-1">
                    {seller.tier !== null && (
                      <Badge variant="outline" className="text-xs">T{seller.tier}</Badge>
                    )}
                    <span className="text-xs text-gray-600">
                      {seller.count} dispute{seller.count !== 1 ? 's' : ''}
                    </span>
                    {seller.rate && (
                      <span className="text-xs text-gray-500">({(seller.rate * 100).toFixed(1)}%)</span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
